export const CalendarValidityConstant = {
    Service: 'SERVICE',
    Sale: 'SALE'
}